export default __webpack_public_path__ + "static/media/egg.3c26e6a3.png";